import { useEffect } from "react";
import "../styles/Contents.css";

export default function TestSeries() {
  useEffect(() => {
    const elements = document.querySelectorAll(
      ".reveal, .reveal-left, .reveal-right"
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("active");
          } else {
            entry.target.classList.remove("active");
          }
        });
      },
      { threshold: 0.15 }
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="page">
      {/* HERO */}
      <section className="about-hero reveal">
        <h1>Test Series</h1>
        <p>
          Experience real exam pressure with expertly designed test series that
          sharpen accuracy, speed, confidence, and exam temperament.
        </p>
      </section>

      {/* SECTION 1 */}
      <section className="about-section reveal-left">
        <div className="about-row">
          <div className="about-content">
            <h2>📝 Exam-Oriented Test Design</h2>
            <p>
              Our test series is designed strictly according to the latest board
              and competitive exam patterns to ensure relevant and effective
              preparation.
            </p>
            <ul>
              <li>Based on updated syllabus and blueprint</li>
              <li>Balanced mix of easy, moderate, and challenging questions</li>
              <li>Covers conceptual, application, and analytical questions</li>
              <li>Helps students understand exam expectations clearly</li>
            </ul>
          </div>
          <img
            src="/images/test.jpg"
            alt="Exam Test Series"
            className="about-image"
          />
        </div>
      </section>

      {/* SECTION 2 */}
      <section className="about-section reveal-right">
        <div className="about-row reverse">
          <div className="about-content">
            <h2>⏱️ Real Exam Simulation</h2>
            <p>
              Timed tests conducted in a real-exam environment help students
              develop speed, focus, and mental endurance.
            </p>
            <ul>
              <li>Strict exam timings followed</li>
              <li>OMR / answer-sheet practice (where applicable)</li>
              <li>Improves time management skills</li>
              <li>Reduces exam fear and anxiety</li>
              <li>Builds confidence through repeated exposure</li>
            </ul>
          </div>

          <img
            src="/images/time-management.jpg"
            alt="Timed Tests"
            className="about-image"
          />
        </div>
      </section>

      {/* SECTION 3 */}
      <section className="about-section reveal-left">
        <div className="about-row">
          <div className="about-content">
            <h2>📊 Detailed Performance Analysis</h2>
            <p>
              Each test is followed by a comprehensive performance report that
              helps students track progress and improve strategically.
            </p>
            <ul>
              <li>Topic-wise and subject-wise analysis</li>
              <li>Accuracy and speed evaluation</li>
              <li>Identification of strong and weak areas</li>
              <li>Rank comparison and score trends</li>
              <li>Clear action plan for improvement</li>
            </ul>
          </div>
          <img
            src="/images/performance.png"
            alt="Performance Analysis"
            className="about-image"
          />
        </div>
      </section>

      {/* SECTION 4 */}
      <section className="about-section reveal-right">
        <div className="about-row reverse">
          <div className="about-content">
            <h2>📘 Expert Solutions & Faculty Feedback</h2>
            <p>
              Students receive detailed solutions along with expert guidance to
              help them learn from mistakes and improve continuously.
            </p>
            <ul>
              <li>Step-by-step solutions for every question</li>
              <li>Concept clarification by experienced faculty</li>
              <li>Personalized feedback and guidance</li>
              <li>Tips to avoid common mistakes</li>
              <li>Improvement strategies after every test</li>
            </ul>
          </div>

          <img
            src="/images/feedback.jpg"
            alt="Test Solutions"
            className="about-image"
          />
        </div>
      </section>

      {/* FOOTER */}
      <section className="about-footer reveal">
        <p>
          ACCESS Test Series empowers students to measure progress, refine exam
          strategies, identify gaps, and walk into examinations with confidence,
          clarity, and control.
        </p>
      </section>
    </div>
  );
}
